import { LifeBuoy } from 'lucide-react'

import {
  useSupportModal,
  type OpenSupportEntry,
  type SupportEntrySource,
} from '@/app/providers/support-modal-provider'
import { cn } from '@/lib/utils'

type ContextualSupportLinkProps = {
  source?: Extract<SupportEntrySource, 'contextual' | 'root-error'>
  contextOverride?: OpenSupportEntry['contextOverride']
  className?: string
}

export function ContextualSupportLink({
  source = 'contextual',
  contextOverride,
  className,
}: ContextualSupportLinkProps) {
  const { openModal } = useSupportModal()

  return (
    <button
      type="button"
      className={cn(
        'inline-flex min-h-11 items-center gap-2 rounded-md text-sm font-medium text-brand-purple underline underline-offset-4',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-purple focus-visible:ring-offset-2',
        className,
      )}
      onClick={() => {
        void openModal({ source, intent: 'problem', contextOverride })
      }}
    >
      <LifeBuoy className="size-4 shrink-0" aria-hidden="true" />
      Bu sorunu bildir
    </button>
  )
}
